<template>
  <div class="home">
    <div class="top-banner"></div>
    <div class="c-padding">
      <div class="swiper-container">
        <van-swipe class="my-swipe" :autoplay="4000" @change="onSwiperChange">
          <van-swipe-item v-for="(item, index) in tabs" :key="index">
            <img
              class="swipe-image"
              @click="bindJump(item)"
              :src="item.image"
              alt=""
            />
          </van-swipe-item>
          <template #indicator>
            <div class="custom-indicator">
              <div
                class="custom-i-item"
                :class="{ 'custom-i-item-active': index == active }"
                v-for="(item, index) in tabs"
                :key="index"
              ></div>
            </div>
          </template>
        </van-swipe>
      </div>
      <van-notice-bar
        left-icon="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/64a6faf7874c053f3bd18c9c880d154e.png"
        :scrollable="true"
        :text="notice"
        color="rgba(0,0,0,0.8)"
      />
      <div class="menu-list">
        <div
          class="menu-item"
          v-for="(item, index) in menuList"
          :key="index"
          @click="bindJump(item)"
        >
          <img class="menu-icon" :src="item.icon" />
          <div class="menu-name">{{ item.name }}</div>
        </div>
      </div>
      <div class="b-menu-list">
        <div
          class="b-menu-item"
          v-for="(item, index) in bottomMenuList"
          :key="index"
          @click="bindJump(item)"
        >
          <img class="b-menu-image" :src="item.image" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BetterweWxApi from '@/components/wx/control.js'
import { ImagePreview } from 'vant'
export default {
  name: 'dounyin-integral-exchange-index',
  data() {
    return {
      active: 0,
      notice: '点击上方卡片即可加入【鹿鹿会员群】',
      tabs: [
        {
          image:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/8fa2877ba6f5801413ee92555934679b.jpg',
          router:
            '/common-preview-image?imageUrl=' +
            encodeURIComponent(
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/dab21ab32651e106ec2cf7e8335bea59.jpg'
            ),
          jumpUrl: ''
        }
        /*  {
                    image: "https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/2206b3608791a579e5d145861c4a00db.png",
                    router: "/common-preview-image?imageUrl=" + encodeURIComponent("https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/b9c23f1eafb858a11c44d89ab7296640.png"),
                    jumpUrl: "",
                },
                {
                    image: "https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/a3fb141d880e0637f8a73080d46ee237.png",
                    router: "/common-preview-image?imageUrl=" + encodeURIComponent("https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/7a4ff40d768fc452dc37a09526fc1a63.png"),
                    jumpUrl: "",
                },
                {
                    image: "https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/d3929b09553d421a38fb80baea028401.png",
                    router: "/common-preview-image?imageUrl=" + encodeURIComponent("https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/84cd5dba0f7524c786c74c70ed808873.jpg"),
                    jumpUrl: "",
                }, */
      ],
      menuList: [
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/df7ce33a1193bddecf6852bced0e9a65.png',
          name: '直播预告',
          router: '',
          jumpUrl: ''
        },
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/9e3d21f26784514d9cd4ee3526a36248.png',
          name: '心愿池',
          router: '',
          jumpUrl: ''
        },
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/f24b26f515b9d3beaec4c1ee543d10b3.png',
          name: '幸运大转盘',
          router: '',
          jumpUrl:
            'https://187447846.lcode2.n.weimob.com/bos/lcode2/187447846/0/2583536846?activityId=30000013686&templateKey=bigwheel'
        },
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/0b4ca3494bee492018bd624c2c7ac95f.png',
          name: '我的',
          router: '',
          jumpUrl: 'http://t.weimob.com/D1_J84f'
        }
      ],
      bottomMenuList: [
        {
          image:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/8747d86562639b676fd54ea16cb52560.png',
          router: '/integral-exchange/exchange',
          jumpUrl: ''
        },
        {
          image:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/1627c253b5025249b2976e3a089b8acf.png',
          router: '',
          jumpUrl: ''
        },
        {
          image:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/35076eaa6bc1353888262aa796d92f5d.png',
          router: '',
          jumpUrl:
            'https://187447846.cms.n.weimob.com/bos/cms/187447846/0/2583566846/design/design?pageid=71785903846'
        },
        {
          image:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/8556d04041478365aca097bbe68a7075.png',
          router: '',
          jumpUrl: 'http://t.weimob.com/Dx_J9lE'
        }
      ]
    }
  },
  activated() {
    this.$http.bindPageUMA()
  },
  created() {
    this.checkLogin()
  },
  mounted() {
    this.setShareOptions()
  },
  methods: {
    onSwiperChange(index) {
      this.active = index
    },
    setShareOptions() {
      let shareOptions = {
        title: '鹿鹿会员中心', // 分享标题
        desc: '直播间订单换积分，超多好礼兑不停', // 分享描述
        imgUrl:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/457f218cf702da3ca1381e68f8c85df3.jpg' // 分享图标
      }
      BetterweWxApi.setShareData(shareOptions, shareOptions)
    },
    checkLogin() {
      this.gym_code = this.$http._getCookie('token')
      if (!this.gym_code && !this.$route.query.refresh) {
        let url = location.href
        let params = url.includes('?') ? '&refresh=1' : '?refresh=1'
        url = url + params
        location.href =
          'http://auth3.gymcity.com.cn/?auth=wegymer&scope=snsapi_userinfo&next=' +
          encodeURIComponent(url)
      }
    },
    bindJump(item) {
      if (item.router) {
        this.$router.push(item.router)
        return
      }
      if (item.jumpUrl) {
        location.href = item.jumpUrl
        return
      }
      if (item.detail) {
        ImagePreview([item.detail])
        return
      }
      this.$toast('即将上线 敬请期待')
    }
  }
}
</script>
<style lang="scss" scoped>
.home {
  min-height: 100vh;
  overflow: hidden;
  background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/721819581adfcab717a221393b27a4da.png');
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center top;
  background-color: #fbf2e5;

  .top-banner {
    height: 239px;
  }

  .c-padding {
    padding: 0px 16px;
  }

  .swiper-container {
    border-radius: 6px;
    overflow: hidden;
    position: relative;
    margin-bottom: 12px;
  }

  .custom-indicator {
    position: absolute;
    left: 50%;
    bottom: 6px;
    transform: translate(-50%, 0%);
    display: flex;
    align-items: center;
    justify-content: center;

    .custom-i-item {
      margin-right: 2px;
      width: 3px;
      height: 3px;
      background: rgba(255, 255, 255, 0.5);
      border-radius: 50%;
    }

    .custom-i-item-active {
      width: 15px;
      height: 3px;
      background: #ffffff;
      border-radius: 2px;
      transition: 0.2s width ease;
    }
  }

  /*   .swiper-container::after {
        content: "NEW";
        position: absolute;
        left: 0;
        top: 0;
        z-index: 9999;
        height: 14px;
        padding: 0 4px;
        background: linear-gradient(90deg, #FF244E 0%, #FF7C61 100%);
        border-radius: 0px 0px 6px 0px;
        font-size: 9px;
        line-height: 14px;
        font-family: AlimamaShuHeiTi, AlimamaShuHeiTi;
        font-weight: bold;
        color: #FFFFFF;
    } */

  .van-notice-bar {
    font-size: 12px;
    height: 30px;
    background: #ffffff;
    border-radius: 8px;
    margin-bottom: 16px;
  }

  .swipe-image {
    width: 100%;
    height: 150px;
    object-fit: cover;
  }

  .notice {
    margin-top: 12px;
    margin-bottom: 16px;
    background: #ffffff;
    border-radius: 8px;
    padding: 7px 16px;
    display: flex;
    align-items: center;

    .notice-content {
      position: relative;
      height: 16px;
      margin-left: 8px;
      flex: 1;
      flex-shrink: 0;
      overflow: hidden;

      .notice-text {
        position: absolute;
        top: 0;
        font-size: 12px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.8);
        line-height: 16px;
        white-space: nowrap;
        position: absolute;
        animation: myMove 10s linear infinite;
      }
    }
  }

  .menu-list {
    margin-bottom: 16px;
    padding: 12px 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #ffffff;
    border-radius: 8px;

    .menu-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .menu-icon {
        width: 42px;
        height: 42px;
        margin-bottom: 4px;
      }

      .menu-name {
        font-size: 11px;
        font-family: PingFangSC, PingFang SC;
        color: rgba(0, 0, 0, 0.8);
        line-height: 16px;
      }
    }
  }

  .b-menu-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-bottom: 16px;

    .b-menu-item {
      width: 168px;
      height: 108px;
      border-radius: 8px;
      margin-bottom: 6px;

      .b-menu-image {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }
}

@keyframes myMove {
  0% {
    left: 0%;
    transform: translateX(0deg);
  }

  50% {
    left: 0%;
    transform: translateX(-100%);
  }

  50.0001% {
    left: 100%;
    transform: translateX(0);
  }

  100% {
    left: 0%;
    transform: translateX(0);
  }
}
</style>
